import NavBar from "./NavBar";

const Developer = () => {
  return (
    <NavBar>
      <div class="container py-3 d-flex flex-column align-items-center">
  <img class="profile" src="https://avatars.githubusercontent.com/u/62208734?v=4" alt="Profile Picture"></img>
  <h1 class="text-light mt-3">Aamir Husssain</h1>
  <a href="https://github.com/aamirbhat382/" class="">Github Profile</a>
</div>

    </NavBar>
  );
};

export default Developer;
